import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useUIStore } from '@/stores/uiStore';

const Breadcrumb: React.FC = () => {
  const { breadcrumbs } = useUIStore();

  if (breadcrumbs.length === 0) return null;

  return (
    <MuiBreadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {breadcrumbs.map((item, index) => {
        const isLast = index === breadcrumbs.length - 1;
        if (isLast) {
          return (
            <Typography key={item.label} color="text.primary" fontSize={14}>
              {item.label}
            </Typography>
          );
        }
        return (
          <Link
            key={item.label}
            component={RouterLink}
            to={item.path || '#'}
            color="inherit"
            fontSize={14}
            underline="hover"
          >
            {item.label}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumb;
